<div class="ce-shell" (click)="fecharSeletorColunas()">
<div class="container">

  <!-- HEADER -->
  <div class="ce-header">
    <div class="ce-title-block">
      <div class="icon-box">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 3v18h18"></path><path d="M18 17V9"></path><path d="M13 17V5"></path><path d="M8 17v-3"></path></svg>
      </div>
      <div class="title-text">
        <h1>Comparação de Estoque</h1>
        <p>Aerosys (Sistema Legado) x Sankhya — casado por código do produto</p>
      </div>
    </div>
  </div>

  <!-- FILTROS -->
  <div class="ce-filtros">
    <div class="filtro-campo">
      <label>Empresa Aerosys</label>
      <select [ngModel]="empresaAerosysSelecionada?.id ?? null" (ngModelChange)="onEmpresaAerosysChange($event)" [disabled]="empresasAerosysCarregando">
        <option [ngValue]="null">Todas as empresas</option>
        <option *ngFor="let e of empresasAerosys" [ngValue]="e.id">{{ e.id }} - {{ e.nome || e.razao }}</option>
      </select>
    </div>

    <div class="filtro-campo">
      <label>Empresa Sankhya</label>
      <select [(ngModel)]="codEmpSankhyaSelecionado">
        <option value="">Todas as empresas</option>
        <option *ngFor="let o of empresaState.opcoes" [value]="o.codEmp">{{ o.codEmp }} - {{ o.nomeFant || o.razaoAbrev }}</option>
      </select>
    </div>

    <button type="button" class="btn-buscar" (click)="buscar()" [disabled]="carregando"><app-loading-indicator *ngIf="carregando" size="inline"></app-loading-indicator>
      {{ carregando ? 'Buscando...' : 'Buscar' }}
    </button>
    <button type="button" class="btn-limpar" (click)="limparFiltros()" [disabled]="carregando">Limpar filtros</button>

    <div class="filtro-campo">
      <label>Comparar por</label>
      <select [ngModel]="tipoComparacao" (ngModelChange)="onTipoComparacaoChange($event)">
        <option *ngFor="let o of opcoesTipoComparacao" [ngValue]="o.valor">{{ o.label }}</option>
      </select>
    </div>

    <div class="filtro-campo filtro-texto">
      <label>Buscar código / descrição / PN</label>
      <input type="text" [ngModel]="filtroTexto" (ngModelChange)="onFiltroTextoChange($event)" placeholder="Ex.: 12345 ou turbina...">
    </div>

    <label class="filtro-check">
      <input type="checkbox" [ngModel]="somenteDivergentes" (ngModelChange)="onSomenteDivergentesChange($event)">
      Somente divergentes
    </label>

    <label class="filtro-check">
      <input type="checkbox" [ngModel]="somenteComEstoqueAerosys" (ngModelChange)="onSomenteComEstoqueAerosysChange($event)">
      Somente com estoque no Aerosys (&gt; 0)
    </label>
  </div>

  <!-- NOTAS EM ANDAMENTO (incompletas -- retomar em vez de recomeçar/duplicar).
       É uma lista de propósito: pode ter uma nota pendente da empresa 4 e outra
       da empresa 1 ao mesmo tempo -- cada uma com seu próprio Retomar/Descartar. -->
  <div class="ce-nota-pendente" *ngFor="let p of notasPendentes">
    <span>
      ⚠️ Nota <strong>{{ p.nunota }}</strong> (empresa {{ p.codemp }}) incompleta —
      {{ p.itensOriginais.length - p.offset }} de {{ p.itensOriginais.length }} item(ns) pendente(s).
    </span>
    <span class="ce-nota-pendente-erro" *ngIf="p.erro && nunotaProcessando !== p.nunota">{{ p.erro }}</span>
    <span class="ce-nota-pendente-progresso" *ngIf="nunotaProcessando === p.nunota">{{ notaEtapa || (progressoNota + '%') }}</span>
    <ng-container *ngIf="nunotaProcessando !== p.nunota">
      <button type="button" class="btn-gerar-nota" [disabled]="gerandoNota" (click)="retomarNotaEmAndamento(p)">Retomar</button>
      <button type="button" class="btn-limpar-selecao" [disabled]="gerandoNota" (click)="descartarNotaPendente(p)">Descartar rastreio</button>
    </ng-container>
  </div>

  <!-- NOTA DE CORREÇÃO -->
  <div class="ce-nota-correcao" *ngIf="resultado && !carregando">
    <span class="nota-selecionados" *ngIf="totalSelecionados > 0">{{ totalSelecionados }} item(ns) selecionado(s)</span>
    <button type="button" class="btn-limpar-selecao" *ngIf="totalSelecionados > 0" (click)="limparSelecao()">Limpar seleção</button>
    <button type="button" class="btn-gerar-nota" [disabled]="!podeGerarNotaCorrecao" (click)="abrirModalNota()"
            [title]="gerandoNota ? 'Aguarde a geração/retomada atual terminar' : (!codEmpSankhyaSelecionado ? 'Escolha uma Empresa Sankhya específica no filtro pra gerar a nota' : (totalSelecionados === 0 ? 'Selecione ao menos um item na coluna Status' : ''))">
      Gerar Nota de Correção
    </button>
  </div>

  <!-- AVISO: Série/Lote exigem empresa Aerosys E Sankhya específicas selecionadas -->
  <p class="ce-modal-aviso ce-aviso-serie-lote" *ngIf="avisoContagemSerieLoteIndisponivel">
    <ng-container *ngIf="resultado?.contagemSerieLoteErro; else semEmpresaSelecionada">
      {{ resultado?.contagemSerieLoteErro }}
    </ng-container>
    <ng-template #semEmpresaSelecionada>
      Pra comparar {{ tipoComparacao === 'SERIE' ? 'Série' : 'Lote/Form' }}, selecione uma empresa Aerosys E uma empresa Sankhya específicas nos filtros acima (série/lote são vinculados a UMA empresa de cada lado).
    </ng-template>
  </p>

  <!-- RESUMO -->
  <div class="ce-resumo" *ngIf="resultado && !carregando">
    <span class="resumo-badge">{{ resultado.total }} produto(s)</span>
    <span class="resumo-badge divergente" *ngIf="totalDivergentesAtual > 0">{{ totalDivergentesAtual }} divergente(s)</span>
    <span class="resumo-badge ok" *ngIf="totalDivergentesAtual === 0">Nenhuma divergência</span>
    <span class="resumo-filtrado" *ngIf="linhasFiltradas.length !== resultado.linhas.length">
      (mostrando {{ linhasFiltradas.length }} após filtro)
    </span>

    <div class="ce-seletores-coluna">
      <div class="seletor-coluna-wrap" (click)="$event.stopPropagation()">
        <button type="button" class="btn-colunas" (click)="toggleSeletorColunas('aerosys')">
          Colunas Aerosys ({{ colunasAerosysVisiveis.size }})
        </button>
        <div class="dropdown-colunas" *ngIf="seletorColunasAberto === 'aerosys'">
          <label class="item-coluna" *ngFor="let campo of resultado.camposAerosys">
            <input type="checkbox" [checked]="colunaVisivel('aerosys', campo)" (change)="alternarColuna('aerosys', campo)">
            {{ campo }}
          </label>
        </div>
      </div>

      <div class="seletor-coluna-wrap" (click)="$event.stopPropagation()">
        <button type="button" class="btn-colunas" (click)="toggleSeletorColunas('sankhya')">
          Colunas Sankhya ({{ colunasSankhyaVisiveis.size }})
        </button>
        <div class="dropdown-colunas" *ngIf="seletorColunasAberto === 'sankhya'">
          <label class="item-coluna" *ngFor="let campo of resultado.camposSankhya">
            <input type="checkbox" [checked]="colunaVisivel('sankhya', campo)" (change)="alternarColuna('sankhya', campo)">
            {{ campo }}
          </label>
        </div>
      </div>
    </div>
  </div>

  <!-- LOADING -->
  <div *ngIf="carregando" class="loading-state">
    <app-loading-indicator></app-loading-indicator>
    <span>Buscando estoque nos dois sistemas...</span>
  </div>

  <!-- ERRO -->
  <div *ngIf="erro && !carregando" class="error-state">
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
    <p>{{ erro }}</p>
  </div>

  <!-- ESTADO INICIAL -->
  <div *ngIf="!jaBuscou && !carregando && !erro" class="empty-state">
    <p>Escolha os filtros de empresa (opcional) e clique em "Buscar" para comparar o estoque.</p>
  </div>

  <!-- VAZIO -->
  <div *ngIf="jaBuscou && !carregando && !erro && resultado && linhasFiltradas.length === 0" class="empty-state">
    <p>Nenhum produto encontrado com os filtros atuais.</p>
  </div>

  <!-- TABELA -->
  <div class="ce-tabela-wrap" *ngIf="!carregando && !erro && resultado && linhasFiltradas.length > 0">
    <table class="ce-tabela">
      <thead>
        <tr>
          <th class="col-selecao" rowspan="2">
            <input type="checkbox" title="Selecionar/desmarcar divergentes desta página" (change)="toggleSelecionarPaginaDivergentes()">
          </th>
          <th class="col-codigo" rowspan="2">Código</th>
          <th class="col-divergente" rowspan="2">Status</th>
          <th [attr.colspan]="colunasAerosysVisiveisOrdenadas.length || 1" class="grupo-aerosys">Aerosys</th>
          <th [attr.colspan]="colunasSankhyaVisiveisOrdenadas.length || 1" class="grupo-sankhya">Sankhya</th>
        </tr>
        <tr>
          <th *ngFor="let campo of colunasAerosysVisiveisOrdenadas" class="grupo-aerosys sub" [ngClass]="classeCampo(campo)">{{ campo }}</th>
          <th *ngIf="colunasAerosysVisiveisOrdenadas.length === 0" class="grupo-aerosys sub">—</th>
          <th *ngFor="let campo of colunasSankhyaVisiveisOrdenadas" class="grupo-sankhya sub" [ngClass]="classeCampo(campo)">{{ campo }}</th>
          <th *ngIf="colunasSankhyaVisiveisOrdenadas.length === 0" class="grupo-sankhya sub">—</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of linhasPaginadas; trackBy: trackByCodigo" [class.linha-divergente]="itemDivergente(item)">
          <td class="col-selecao">
            <input type="checkbox" [checked]="estaSelecionado(item.codigo)" [disabled]="!itemElegivelParaNota(item)"
                   [title]="!itemElegivelParaNota(item) ? 'Sem dado no Aerosys — não é possível corrigir a partir dele' : ''"
                   (change)="toggleSelecao(item)">
          </td>
          <td class="col-codigo">{{ item.codigo }}</td>
          <td class="col-divergente">
            <span class="badge-status divergente" *ngIf="itemDivergente(item)">Divergente</span>
            <span class="badge-status ok" *ngIf="!itemDivergente(item)">OK</span>
            <span class="badge-ausente" *ngIf="!item.aerosys.existe">sem Aerosys</span>
            <span class="badge-ausente" *ngIf="!item.sankhya.existe">sem Sankhya</span>
          </td>
          <td *ngFor="let campo of colunasAerosysVisiveisOrdenadas" class="grupo-aerosys" [ngClass]="classeCampo(campo)" [class.sem-dado]="!item.aerosys.existe" [title]="campoAerosys(item, campo)">
            {{ campoAerosys(item, campo) }}
          </td>
          <td *ngIf="colunasAerosysVisiveisOrdenadas.length === 0" class="grupo-aerosys">—</td>
          <td *ngFor="let campo of colunasSankhyaVisiveisOrdenadas" class="grupo-sankhya" [ngClass]="classeCampo(campo)" [class.sem-dado]="!item.sankhya.existe" [title]="campoSankhya(item, campo)">
            {{ campoSankhya(item, campo) }}
          </td>
          <td *ngIf="colunasSankhyaVisiveisOrdenadas.length === 0" class="grupo-sankhya">—</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- PAGINAÇÃO -->
  <div class="ce-paginacao" *ngIf="!carregando && !erro && resultado && linhasFiltradas.length > 0">
    <div class="paginacao-info">
      Página {{ paginaAtual }} de {{ totalPaginas }} — {{ linhasFiltradas.length }} produto(s)
    </div>
    <div class="paginacao-controles">
      <button type="button" (click)="irParaPagina(1)" [disabled]="paginaAtual === 1">« Primeira</button>
      <button type="button" (click)="paginaAnterior()" [disabled]="paginaAtual === 1">‹ Anterior</button>
      <button type="button" (click)="proximaPagina()" [disabled]="paginaAtual === totalPaginas">Próxima ›</button>
      <button type="button" (click)="irParaPagina(totalPaginas)" [disabled]="paginaAtual === totalPaginas">Última »</button>
      <select [ngModel]="itensPorPagina" (ngModelChange)="onItensPorPaginaChange($event)">
        <option *ngFor="let n of opcoesItensPorPagina" [ngValue]="n">{{ n }} por página</option>
      </select>
    </div>
  </div>

  <!-- MODAL: NOTA DE CORREÇÃO (prévia + execução) -->
  <div class="ce-modal-overlay" *ngIf="mostrarModalNota" (click)="fecharModalNota()">
    <div class="ce-modal" (click)="$event.stopPropagation()">
      <div class="ce-modal-header">
        <h2>Gerar Nota de Correção</h2>
        <button type="button" class="ce-modal-fechar" (click)="fecharModalNota()" [disabled]="gerandoNota">×</button>
      </div>

      <div class="ce-modal-body">

        <!-- ESTADO: PRÉVIA (antes de confirmar) -->
        <ng-container *ngIf="!notaResultado && !notaErro">
          <p class="ce-modal-aviso">
            Aerosys é a fonte da verdade: os itens abaixo serão corrigidos no Sankhya (empresa {{ codEmpSankhyaSelecionado }})
            para bater com a quantidade e o local do Aerosys. Fase 1 corrige <strong>quantidade</strong> e
            <strong>local</strong>; Fase 2 atribui <strong>número de série</strong>; Fase 3 atribui <strong>lote/form</strong>
            (pode gerar mais de uma linha por produto quando a quantidade vem de mais de um lote, pra não perder
            rastreabilidade). Revise antes de confirmar.
          </p>

          <p class="ce-modal-aviso" *ngIf="carregandoSeriais">Verificando seriais e lotes/forms disponíveis no Aerosys...</p>

          <div class="ce-modal-tabela-wrap">
            <table class="ce-modal-tabela">
              <thead>
                <tr>
                  <th>Código</th>
                  <th>Descrição</th>
                  <th>Qtde atual (Sankhya)</th>
                  <th>Qtde nova (Aerosys)</th>
                  <th>Local atual (Sankhya)</th>
                  <th>Local novo (Aerosys)</th>
                  <th>Série</th>
                  <th>Lote/Form</th>
                  <th>Documento</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let p of itensPreviewNota">
                  <td>{{ p.codigo }}</td>
                  <td class="col-descricao" [title]="p.descricao">{{ p.descricao }}</td>
                  <td [class.valor-mudou]="p.qtdeAtual !== p.qtdeNova">{{ p.qtdeAtual ?? '—' }}</td>
                  <td [class.valor-novo]="p.qtdeAtual !== p.qtdeNova">{{ p.qtdeNova ?? '—' }}</td>
                  <td class="col-local" [class.valor-mudou]="p.localAtual !== p.localNovo" [title]="p.localAtual">{{ p.localAtual || '—' }}</td>
                  <td class="col-local" [class.valor-novo]="p.localAtual !== p.localNovo" [title]="p.localNovo">{{ p.localNovo || '—' }}</td>
                  <td class="col-serie" [title]="p.avisoSerial || ''">
                    <span *ngIf="p.seriais?.length">{{ p.seriais?.length }} atribuída(s)</span>
                    <span *ngIf="p.avisoSerial" class="ce-serie-aviso">⚠</span>
                  </td>
                  <td class="col-serie" [title]="_tituloLote(p)">
                    <span *ngIf="p.alocacoesLote?.length">{{ p.alocacoesLote?.length }} lote(s)</span>
                    <span *ngIf="p.avisoLote" class="ce-serie-aviso">⚠</span>
                  </td>
                  <td class="col-documento">
                    <ng-container *ngIf="p.documentos?.length; else semDocumento">
                      <select class="ce-doc-select"
                              [ngModel]="p.documentoEscolhidoIcoId"
                              (ngModelChange)="selecionarDocumento(p, $event)"
                              [ngModelOptions]="{standalone: true}"
                              title="Documento a anexar na nota (ou 'Não anexar')">
                        <option [ngValue]="null">Não anexar</option>
                        <option *ngFor="let doc of p.documentos" [ngValue]="doc.icoId">
                          {{ doc.formNumero || doc.formLote || ('doc ' + doc.icoId) }}{{ doc.cprNumTitulo ? ' — ' + doc.cprNumTitulo : '' }}
                        </option>
                      </select>
                      <button type="button" class="ce-doc-ver"
                              *ngIf="p.documentoEscolhidoIcoId"
                              (click)="visualizarDocumento(p.documentoEscolhidoIcoId, 'documento_' + p.codigo + '.pdf')"
                              title="Visualizar PDF">Ver</button>
                    </ng-container>
                    <ng-template #semDocumento>
                      <span class="ce-doc-nenhum">—</span>
                    </ng-template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <p class="ce-modal-aviso" *ngIf="totalDocumentosEscolhidos > 0">
            {{ totalDocumentosEscolhidos }} documento(s) serão anexados à nota (como documentação/rastreabilidade) depois que ela for gerada com sucesso.
          </p>

          <div class="ce-modal-progresso" *ngIf="gerandoNota">
            <div class="progresso-barra"><div class="progresso-preenchido" [style.width.%]="progressoNota"></div></div>
            <span>{{ notaEtapa || (progressoNota + '%') }}</span>
          </div>

          <div class="ce-modal-acoes">
            <button type="button" class="btn-limpar" (click)="fecharModalNota()" [disabled]="gerandoNota">Cancelar</button>
            <button type="button" class="btn-gerar-nota" (click)="confirmarGerarNota()"
                    [disabled]="gerandoNota || carregandoSeriais"
                    [title]="carregandoSeriais ? 'Aguarde a verificação de seriais/lotes terminar' : ''"><app-loading-indicator *ngIf="gerandoNota" size="inline"></app-loading-indicator>
              {{ gerandoNota ? 'Gerando...' : (carregandoSeriais ? 'Verificando...' : ('Confirmar e gerar (' + itensSubmissaoNota.length + ' linha(s))')) }}
            </button>
          </div>
        </ng-container>

        <!-- ESTADO: SUCESSO -->
        <div class="ce-modal-resultado sucesso" *ngIf="notaResultado">
          <p>✅ Nota de correção <strong>{{ notaResultado.nunota }}</strong> gerada com {{ notaResultado.totalItens }} item(ns).</p>
          <p *ngIf="notaErro" class="ce-modal-aviso-erro">{{ notaErro }}</p>
          <p *ngIf="notaItensNaoImportados.length" class="ce-modal-aviso-erro">
            {{ notaItensNaoImportados.length }} item(ns) não foram importados — verifique quantidade/local desses produtos.
          </p>
          <p class="ce-modal-aviso" *ngIf="anexandoDocumentos">Anexando documentos na nota...</p>
          <p class="ce-modal-aviso" *ngIf="!anexandoDocumentos && notaAnexosResultado">
            📎 {{ notaAnexosResultado.sucesso }} de {{ notaAnexosResultado.total }} documento(s) anexado(s) com sucesso.
            <span *ngIf="notaAnexosResultado.falha" class="ce-modal-aviso-erro"> {{ notaAnexosResultado.falha }} falhou/falharam ao anexar — a nota {{ notaResultado?.nunota }} foi gerada normalmente, só o(s) documento(s) que não anexou(aram) precisa(m) ser adicionado(s) manualmente depois.</span>
          </p>
          <div class="ce-modal-acoes">
            <button type="button" class="btn-gerar-nota" (click)="fecharResultadoNota()" [disabled]="anexandoDocumentos">Fechar e atualizar comparação</button>
          </div>
        </div>

        <!-- ESTADO: ERRO (sem nota gerada) -->
        <div class="ce-modal-resultado erro" *ngIf="notaErro && !notaResultado">
          <p>{{ notaErro }}</p>
          <div class="ce-modal-acoes">
            <button type="button" class="btn-limpar" (click)="fecharResultadoNota()">Fechar</button>
          </div>
        </div>

      </div>
    </div>
  </div>

  <!-- OVERLAY: PREVIEW DO PDF (documento de compra) -->
  <div class="ce-modal-overlay ce-pdf-overlay" *ngIf="previewPdfUrl || previewPdfCarregando || previewPdfErro" (click)="fecharPreviewPdf()">
    <div class="ce-modal ce-pdf-modal" (click)="$event.stopPropagation()">
      <div class="ce-modal-header">
        <h2>{{ previewPdfNome || 'Documento' }}</h2>
        <button type="button" class="ce-modal-fechar" (click)="fecharPreviewPdf()">×</button>
      </div>
      <div class="ce-modal-body ce-pdf-body">
        <p *ngIf="previewPdfCarregando" class="ce-modal-aviso"><app-loading-indicator size="inline"></app-loading-indicator> Carregando PDF...</p>
        <p *ngIf="previewPdfErro" class="ce-modal-aviso-erro">{{ previewPdfErro }}</p>
        <iframe *ngIf="previewPdfUrl" [src]="previewPdfUrl" class="ce-pdf-iframe"></iframe>
      </div>
    </div>
  </div>

</div>
</div>
